import cn from 'classnames'
import type {PricingSectionSlice} from 'prismicio-types'

type BackgroundColor = 'Moss White' | 'Green/700' | 'Beige/300' | 'Neon Green' | 'Dark Green' | null

/**
 * Get background color classes for module cards
 */
export const getModuleCardBackgroundClass = (backgroundColor: BackgroundColor) =>
  cn({
    'bg-moss-white': backgroundColor === 'Moss White',
    'bg-moss-green-700': backgroundColor === 'Green/700',
    'bg-beige-300': backgroundColor === 'Beige/300',
    'bg-green-neon': backgroundColor === 'Neon Green',
    'bg-green-dark': backgroundColor === 'Dark Green',
  })

/**
 * Get text color classes for module card titles
 */
export const getModuleCardTitleTextClass = (backgroundColor: BackgroundColor) =>
  cn('text-moss-black', {
    'text-moss-black': backgroundColor !== 'Green/700' && backgroundColor !== 'Dark Green',
    'text-moss-white': backgroundColor === 'Green/700' || backgroundColor === 'Dark Green',
  })

/**
 * Get text color classes for module card descriptions
 */
export const getModuleCardDescriptionTextClass = (
  backgroundColor: BackgroundColor,
  variation?: PricingSectionSlice['variation'],
) =>
  cn({
    'text-grey-550':
      backgroundColor !== 'Green/700' && backgroundColor !== 'Neon Green' && backgroundColor !== 'Dark Green',
    'text-grey-120': backgroundColor === 'Green/700' && variation !== 'reskin',
    'text-moss-white': backgroundColor === 'Dark Green',
    'text-grey-900': backgroundColor === 'Neon Green',
  })

/**
 * Check if background is dark (requires light text)
 */
export const isDarkBackground = (backgroundColor: BackgroundColor) =>
  backgroundColor === 'Green/700' || backgroundColor === 'Dark Green'
